<template>
  <span class="font-bold text-3xl inline-block">Codes</span><br />
  <button v-if="!started"
    class="border-black border-2 bg-green-500 rounded-lg px-3 py-2 mt-4 text-white font-bold"
    @click="startNFC()"
  >
    Start Scanning
  </button><br />

  <div v-for="code in codes" :key="code" class="mt-2">
    <span class="font-bold text-xl" @click="copyToClipboard(code)">{{
      code
    }}</span
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      codes: [],
      started:false,
    };
  },
  methods: {
    loadRescanner(startNFC = false) {
      let vm = this;
      if (!window.rescanner) {
        let rescannerLib = document.createElement("script");
        rescannerLib.setAttribute("src", "/rescanner.js");
        rescannerLib.onload = () => {
          window.rescanner.onNFCSuccess = (message) => {
            vm.scanResult(message);
          };
          window.rescanner.onQRSuccess = (message) => {
            vm.scanResult(message);
          };
          if (startNFC) window.rescanner.startNFCScan();
        };
        document.head.appendChild(rescannerLib);
      } else {
        window.rescanner.onNFCSuccess = (message) => {
          vm.scanResult(message);
        };
        window.rescanner.onQRSuccess = (message) => {
          vm.scanResult(message);
        };
        if (startNFC) window.rescanner.startNFCScan();
      }
    },
    scanResult(message) {
      fetch("https://s.rescanner.de/shopr", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          code: message,
        }),
      });
    },
    startNFC() {
      window.rescanner.startNFCScan();
      this.started=true
    },
    copyToClipboard(code) {
      navigator.clipboard.writeText(code);
    },
    openWebSocket() {
      const url = `wss://s.rescanner.de/ws/shopr`;
      if (this.webSocket) {
        this.webSocket.close();
      }
      this.webSocket = new WebSocket(url);

      this.webSocket.onmessage = (event) => {
        try {
          let data = JSON.parse(event.data);
          if (data.code) {
            this.codes.unshift(data.code.replaceAll(":", "").trim().toUpperCase());
          }
        } catch (ignore) {}
      };
    },
  },
  mounted() {
    this.loadRescanner(false);
    this.openWebSocket();
  },
};
</script>